<template>
  <div class="emb-FinalReceipt-wrap" v-if="userDetails">
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    </div>
    <emb-page-title :heading="bannerSection.Heading" :image="bannerSection.Image_1920x700px"></emb-page-title>
    <div class="final-receipt section-gap">
      <v-container grid-list-xl py-0>
        <v-layout align-center justify-center>
          <v-flex xs12 sm12 md10 lg7 xl7>
            <div class="emb-card pb-12">
              <div id="payment-receipt">
                <div class="text-center bg-grey pa-sm-12 pa-6">
                  <h1>{{paymentSection.Title}}</h1>
                  <h5 class="mb-6">{{paymentSection.Subtitle}}</h5>
                  <h6
                    class="mb-6"
                  >{{paymentSection.Transction_Id_Label}}: {{invoiceData.transactionId}}</h6>
                  <img :src="paymentSection.image64x64px" width="64" height="64" alt="Success" />
                </div>
                <div class="py-sm-12 py-8 px-sm-6 px-4">
                  <v-layout row wrap mb-6>
                    <v-flex xs12 sm6 md6 lg6 xl6>
                      <h6>{{paymentSection.Summary_Label}}</h6>
                      <!-- <p
                        class="mb-1 text-capitalize"
                      >{{paymentSection.Order_ID_Label}}: {{invoiceData.orderId}}</p>-->
                      <p
                        class="mb-1"
                      >{{paymentSection.Order_Date_Label}}: {{invoiceData.orderedDate}}</p>
                      <p class="mb-1">
                        {{paymentSection.Order_Total_Label}}:
                        <!-- <emb-currency-sign></emb-currency-sign> -->
                        {{ $n((itemTotal+shippingCharge)/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency) }}
                        <!-- {{getTotalPrice()}} -->
                      </p>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg6 xl6>
                      <h6>{{paymentSection.Ship_To_Label}}</h6>
                      <p class="mb-1">{{userDetails.shippingAddress.keyword1}}</p>
                      <p class="mb-1">{{userDetails.shippingAddress.keyword3}}</p>
                      <p class="mb-1">{{userDetails.shippingAddress.keyword4}}</p>
                      <p class="mb-1">{{userDetails.shippingAddress.keyword13}}</p>
                      <p class="mb-1">{{userDetails.shippingAddress.keyword6}}</p>
                      <p
                        class="mb-1"
                      >{{userDetails.shippingAddress.keyword7}} - {{userDetails.shippingAddress.keyword5}}</p>
                      <p class="mb-1">{{userDetails.shippingAddress.keyword8}}</p>
                    </v-flex>
                  </v-layout>
                  <!-- <div class="py-6 text-center bg-grey px-3">
                    <h4>{{paymentSection.Delivery_Label}}</h4>
                    <h3>{{invoiceData.deliveryDate}}</h3>
                  </div>-->
                  <h4 class="pt-6">{{paymentSection.Ordered_Details_Label}}</h4>
                  <template v-for="(cart, index) in invoiceData.products">
                    <div
                      class="layout row wrap align-center d-flex my-0 text-md-left text-center"
                      v-if="invoiceData.products"
                      :key="index"
                    >
                      <v-flex xs12 sm12 md3 lg3 xl3>
                        <img alt="cart Image" width="100" :src="cart.Product_Image_626_x_800px" />
                      </v-flex>
                      <v-flex xs12 sm4 md3 lg3 xl3>
                        <h6>{{paymentSection.Product_Name_Label}}</h6>
                        <p class="mb-0 font-weight-bold">{{cart.Name}}</p>
                      </v-flex>
                      <v-flex xs6 sm4 md3 lg3 xl3>
                        <h6>{{paymentSection.Quantity_Label}}</h6>
                        <p class="mb-0">{{cart.quantitySelected}}</p>
                      </v-flex>
                      <v-flex xs6 sm4 md3 lg3 xl3>
                        <h6>{{paymentSection.Price}}</h6>
                        <p
                          class="mb-0"
                        >{{ $n((cart.sellingPrice/selectCurrency.CurrencyMultiplier),'currency',selectCurrency.selectedCurrency)}}</p>
                      </v-flex>
                    </div>
                  </template>
                  <v-divider class="my-4"></v-divider>
                  <div>
                    <div class="d-flex align-center justify-space-between mt-4 mb-4">
                      <div>
                        <p class="mb-0">{{paymentSection.Subtotal_Label}}</p>
                      </div>
                      <div>
                        <span>
                          <!-- <emb-currency-sign></emb-currency-sign> -->
                          {{ $n(itemTotal/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency) }}
                          <!-- {{itemTotal()}} -->
                        </span>
                      </div>
                    </div>
                    <div class="d-flex align-center justify-space-between mb-4">
                      <p class="mb-0">{{paymentSection.Shipping_Label}}</p>
                      <span>
                        <!-- <emb-currency-sign></emb-currency-sign> -->
                        {{ $n(shippingCharge/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency) }}
                        <!-- {{shipping}} -->
                      </span>
                    </div>
                    <!-- <div class="d-flex align-center justify-space-between mb-4">
                      <p class="mb-0">{{paymentSection.Tax_Label}}</p>
                      <span>
                        <emb-currency-sign></emb-currency-sign>
                        {{tax}}
                      </span>
                    </div>-->
                  </div>
                  <v-divider class="my-4"></v-divider>
                  <div class="d-flex align-center justify-space-between">
                    <h4>{{paymentSection.Total_Label}}</h4>
                    <h4>
                      <!-- <emb-currency-sign></emb-currency-sign> -->
                      {{ $n((itemTotal+shippingCharge)/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency) }}
                      <!-- {{getTotalPrice()}} -->
                    </h4>
                  </div>
                </div>
              </div>
              <div class="layout row wrap pt-6 px-4 text-center">
                <!-- <v-flex xs12 sm6 md6 lg6 xl6 text-md-left>
                  <v-btn class="accent" large>{{paymentSection.Pdf_Button_Label}}</v-btn>
                </v-flex>-->
                <!-- <v-flex xs12 sm6 md6 lg6 xl6 text-md-right>
                  <v-btn class="accent" large to="/">{{paymentSection.Go_To_Home_Button_Label}}</v-btn>
                </v-flex>-->

                <v-flex xs12 sm6 md6 lg6 xl6 text-md-left>
                  <v-btn class="accent" large to="/">{{paymentSection.Go_To_Home_Button_Label}}</v-btn>
                </v-flex>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import gettingRestClientObject from "../../services/utils/cms-helper";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import FeatureVue from "../components/Widgets/Feature.vue";
export default {
  computed: {
    ...mapGetters([
      "invoiceData",
      "userDetails",
      "paymentInfo",
      "selectCurrency",
      "selectedLocale",
    ]),
    itemTotal() {
      return this.invoiceData.products.reduce((total, product) => {
        return total + product.sellingPrice * product.quantitySelected;
      }, 0);
    },
    shippingCharge() {
      if (
        this.deliveryInfo.Threshold_Price != null &&
        this.deliveryInfo.Threshold_Price != ""
      ) {
        if (this.deliveryInfo.Threshold_Price < this.itemTotal) {
          return this.deliveryInfo.Threshold_Price_Above
            ? Number(this.deliveryInfo.Threshold_Price_Above)
            : 0;
        } else {
          return this.deliveryInfo.Threshold_Price_Below
            ? Number(this.deliveryInfo.Threshold_Price_Below)
            : 0;
        }
      } else {
        return 0;
      }
    },
  },
  watch: {
    selectedLocale() {
      this.getPageData();
      this.getPageData2();
    },
  },
  components: {
    Loading,
  },
  data() {
    return {
      paymentSection: "",
      bannerSection: "",
      isLoading: false,
      ContactSection: {},
      deliveryInfo: {
        Threshold_Price: "",
        Threshold_Price_Above: "",
        Threshold_Price_Below: "",
      },
      selectedCurrency: localStorage.selectedCurrency
        ? localStorage.selectedCurrency
        : "AED",
      CurrencyMultiplier: localStorage.CurrencyMultiplier
        ? parseFloat(localStorage.CurrencyMultiplier)
        : parseFloat(1),
    };
  },
  created() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getFooterPage();
    this.getPageData();
    this.getPageData2();
  },
  async mounted() {
    this.isLoading = true;
    this.$store.dispatch("removeCartItems");
    setTimeout(async () => {
      await this.postOrder();
    }, 1000);
  },
  destroyed() {
    this.$store.dispatch("destroyProducts");
    this.$store.dispatch("destroyPaymentInfo");
  },

  methods: {
    /**
     * this function returns the delivery date
     **/
    deliveryDate() {
      let format = "MMMM Do , YYYY";
      let startdate = moment().format(format);
      var new_date = moment(startdate, format).add(5, "days");
      return new_date.format(format);
    },
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl:
          "28  Final Payment Receipt/28  Final Payment Receipt/28  Final Payment Receipt.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var payment = self.cmsRequestFunctions.pluck(
              "Receipt_Section",
              res.area_List
            );

            self.paymentSection = self.cmsRequestFunctions.getAllMapData(
              payment[0].component
            );
            var bannerArea = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );
            self.bannerSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    getPageData2: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "25 Check Out/25 Check Out/25 Check Out.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;

          if (res.area_List) {
            var deliveryInfo = self.cmsRequestFunctions.pluck(
              "Delivery_Info_Section",
              res.area_List
            );
            self.deliveryInfo = self.cmsRequestFunctions.getAllMapData(
              deliveryInfo[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    getFooterPage: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "03 Footer/03 Footer/03 Footer.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var contactArea = self.cmsRequestFunctions.pluck(
              "Contact_Section",
              res.area_List
            );
            self.ContactSection = self.cmsRequestFunctions.getAllMapData(
              contactArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    sendMail: async function (orderId) {
      var self = this;

      try {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        var userInfo = JSON.parse(localStorage.embryo);
        var products = [];
        for (let cart of self.invoiceData.products) {
          let product = {
            itemName: cart.Name,
            itemQtyWithUnitprice: cart.quantitySelected,
            itemSpec: "",
            total: self.$n(
              Number(cart.sellingPrice) /
                self.selectCurrency.CurrencyMultiplier,
              "currency",
              self.selectCurrency.selectedCurrency
            ),
          };
          products.push(product);
        }
        var emailData = {
          type: "SoupOrderReceivedRequest",
          fromEmail: "shibu@sgtechconsultants.com",
          toEmails: [userInfo.user_data.email],
          ccEmails: [self.ContactSection.Email],
          bccEmails: null,
          primaryColor: null,
          secondaryColor: null,
          subject: "Order Placed",
          logoUrl:
            "https://ov-cms.s3.ap-south-1.amazonaws.com/B2B/AdminPanel/CMS/AGY20518/Images/25082020105742.png",
          amountWithPaymentStatus:
            self.paymentInfo.ID == 1 ? "Cash on delivery" : "Paid",
          date: requestedDate,
          customerName: userInfo.user_data.name,
          message: "Thank you for ordering Product",
          orderId: orderId,
          orderStatus: "Order Placed",
          hotelName: userInfo.user_data.name,
          hotelAddress: "",
          hotelImage:
            'https://ci6.googleusercontent.com/proxy/t35sjWBDskYxYYH8v-rhqRPOXNrmDsAix4DTJghnTG8XmV1fv6xg_Vc0_j2Wl0ir0eWehY9Gg1sVbdZnTNMz8hZMsL8AaV5DMEZ3YrfKATV-YQmtKwgfQPjaNtWzaj9WLeEK=s0-d-e1-ft#https://ecart-fileserver.s3.ap-south-1.amazonaws.com/Email/Template/delivery.png" alt="alt text" style="width:100%;text-align:center;border:0;outline:none;text-decoration:none;border-radius:8px;height:auto',
          orderedItems: products,
          extraCharges: [
            {
              attributeName: "Delivery Charge",
              attributeValue: self.$n(
                self.shippingCharge / self.selectCurrency.CurrencyMultiplier,
                "currency",
                self.selectCurrency.selectedCurrency
              ),
            },
          ],
          modeOfPayment: self.paymentInfo.Payment_Method_Name,
          totalPayableAmount: self.$n(
            (self.itemTotal + self.shippingCharge) /
              self.selectCurrency.CurrencyMultiplier,
            "currency",
            self.selectCurrency.selectedCurrency
          ),
          siteLink: "http://ecomdemo.sgspartnerworld.com/",
          siteName: "SGS Partner World",
          copyRight: "",
          portalAddress: self.ContactSection.Email,
        };

        let orderSuccess = await self.cmsRequestFunctions.sendMail(emailData);
        console.log(orderSuccess);
        self.isLoading = false;
      } catch (error) {
        console.log("Error Checkout Mail");
        this.isLoading = false;
      }
    },
    postOrder: async function () {
      var self = this;
      try {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        var billingAddress;
        billingAddress =
          self.userDetails.firstName +
          ", " +
          self.userDetails.aptBuilding +
          ", " +
          self.userDetails.streetName +
          ", " +
          self.userDetails.city +
          ", " +
          self.userDetails.zipCode;

        let OrderIdDate = moment(String(new Date())).format("YYYYMMDDThhmmss");
        var userInfo = JSON.parse(localStorage.embryo);
        var orderId = "ORD" + "USER" + OrderIdDate;
        orderId = orderId.toUpperCase();
        // var totalPaid = 0;
        var productText = "";
        for (let index = 0; index < self.invoiceData.products.length; index++) {
          // for Feature dynamic property
          // var keys = Object.keys(self.invoiceData.products[index]);
          // console.log(index, ":", keys);
          var color, size;
          if (self.invoiceData.products[index].Color) {
            color = "[Colour : " + self.invoiceData.products[index].Color + "]";
          } else {
            color = "";
          }
          if (self.invoiceData.products[index].Size) {
            size = "[Size : " + self.invoiceData.products[index].Size + "]";
          } else {
            size = "";
          }
          productText +=
            "\n" +
            self.invoiceData.products[index].Name +
            color +
            size +
            "\t" +
            "x" +
            self.invoiceData.products[index].quantitySelected +
            "\t" +
            self.$n(
              self.invoiceData.products[index].sellingPrice /
                self.selectCurrency.CurrencyMultiplier,
              "currency",
              self.selectCurrency.selectedCurrency
            ) +
            "\n";

          var itemTotal =
            Number(self.invoiceData.products[index].sellingPrice) *
            self.invoiceData.products[index].quantitySelected;
          self.invoiceData.products[index].itemTotal = Number(
            self
              .$n(
                Number(itemTotal) / self.selectCurrency.CurrencyMultiplier,
                null,
                self.selectCurrency.selectedCurrency
              )
              .replace(/,/g, "")
          );

          self.invoiceData.products[index].itemCost = Number(
            self
              .$n(
                Number(self.invoiceData.products[index].sellingPrice) /
                  self.selectCurrency.CurrencyMultiplier,
                null,
                self.selectCurrency.selectedCurrency
              )
              .replace(/,/g, "")
          );
        }
        console.log(productText);
        let insertOrderData = {
          type: "Booking",
          date1: requestedDate,
          keyword1: orderId,
          keyword2: userInfo.user_data.loginId,
          text1: userInfo.user_data.name,
          keyword3: userInfo.user_data.phoneNumber,
          keyword4: userInfo.user_data.email,
          nested2: self.invoiceData.products,
          amount1: Number(
            self
              .$n(
                self.shippingCharge / self.selectCurrency.CurrencyMultiplier,
                null,
                self.selectCurrency.selectedCurrency
              )
              .replace(/,/g, "")
          ),
          amount2: Number(
            self
              .$n(
                self.itemTotal / self.selectCurrency.CurrencyMultiplier,
                null,
                self.selectCurrency.selectedCurrency
              )
              .replace(/,/g, "")
          ),
          amount3: Number(
            self
              .$n(
                (self.itemTotal + self.shippingCharge) /
                  self.selectCurrency.CurrencyMultiplier,
                null,
                self.selectCurrency.selectedCurrency
              )
              .replace(/,/g, "")
          ),
          text2: self.paymentInfo.Payment_Method_Name,
          text3:
            self.userDetails.shippingAddress.keyword1 +
            ", " +
            self.userDetails.shippingAddress.keyword3 +
            ", " +
            self.userDetails.shippingAddress.keyword4 +
            ", " +
            self.userDetails.shippingAddress.keyword6 +
            ", " +
            self.userDetails.shippingAddress.keyword5,
          text4: billingAddress,
          keyword5: self.selectCurrency.selectedCurrency,
          keyword6: localStorage.Language
            ? localStorage.Language
            : "en" || "en",
          text5: self.userDetails.city,
          text6: self.userDetails.country,
          text7: self.userDetails.shippingAddress.keyword13,
          text8: self.userDetails.shippingAddress.keyword7,
          text10: productText,
        };
        var orderSuccess = await self.cmsRequestFunctions.cmsFormData(
          insertOrderData
        );
        console.log(orderSuccess);

        await self.sendMail(orderId);
      } catch (error) {
        console.log("Error Checkout");
        this.isLoading = false;
      }
    },
  },
};
</script>
